module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_fruity_citrus-ce725b10.png";